import { render, staticRenderFns } from "./CreditClassStudentSave.vue?vue&type=template&id=96d72b06&"
import script from "./CreditClassStudentSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassStudentSave.vue?vue&type=script&lang=js&"
import style0 from "./CreditClassStudentSave.vue?vue&type=style&index=0&id=96d72b06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports